module.exports = __webpack_public_path__ + "img/lc.68b5aa1b.jpg";